/** @jsxImportSource @emotion/react */
import React from 'react';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import Text from 'ud-ui/components/text';
import * as S from './styles';

type Status = 'shading' | 'primary' | 'secondary';

export interface StatusItem {
  label: string;
  status: Status;
  count: number;
}

interface IProps extends DivProps {
  data: StatusItem[];
}

function StatusDistributionBar(props: IProps) {
  const { data, ...rest } = props;
  const total = data.reduce((sum, item) => sum + item.count, 0);

  return (
    <div {...rest}>
      <S.Header>
        {data.map(({ label, status }) => (
          <S.LegendItem key={status}>
            <S.LegendColor className={status} />
            <Text variant="subtitle-1" color={theme.colors.Gray}>
              {label}
            </Text>
          </S.LegendItem>
        ))}
      </S.Header>

      <S.MainBlock>
        {data.map(({ status, count }, idx) => {
          const width = (count / total) * 100;
          return (
            <div style={{ flexBasis: `${width}%` }}>
              <S.CountMarker key={idx}>
                <S.DashedLine />
                <Text variant="body-3">{count}</Text>
              </S.CountMarker>
              <S.Block key={status} className={status} />
            </div>
          );
        })}
      </S.MainBlock>
    </div>
  );
}

export default StatusDistributionBar;
